import { ITEM_TYPES } from '@wix/advanced-seo-utils';
export var setPageSeo = function (_a) {
    var wixCodeApi = _a.wixCodeApi, coverUrl = _a.coverUrl, sets = _a.sets, albumData = _a.albumData;
    var albumName = albumData.albumName;
    if (!wixCodeApi.location.prefix) {
        wixCodeApi.seo.renderSEOTags({
            itemType: ITEM_TYPES.DEFAULT,
            itemData: {},
            seoData: {
                tags: [
                    {
                        type: 'meta',
                        props: {
                            property: 'og:image',
                            content: coverUrl,
                        },
                        custom: false,
                        disabled: false,
                    },
                ],
            },
        });
    }
    if (wixCodeApi.location.prefix === 'set' &&
        wixCodeApi.location.path.length > 0) {
        var setId_1 = wixCodeApi.location.path[0];
        var currentSet = sets.find(function (x) { return x.id === setId_1; });
        var pageTitleString = currentSet
            ? currentSet.name +
                (albumName && currentSet.name ? ' | ' : '') +
                albumName
            : albumName;
        wixCodeApi.seo.setTitle(pageTitleString);
    }
    else if (!wixCodeApi.location.prefix &&
        wixCodeApi.location.path[0] === 'sets') {
        wixCodeApi.seo.setTitle('Sets | ' + albumName);
    }
    else if (!wixCodeApi.location.prefix &&
        wixCodeApi.location.path.length === 0) {
        wixCodeApi.seo.setTitle(albumName);
    }
};
//# sourceMappingURL=seoService.js.map